import type { SnackbarProviderOptions, SnackbarState } from './types';

type AddSnackbarOptions = Required<
  Pick<SnackbarProviderOptions, 'showLatestOnTop' | 'snackbarLimit'>
>;

type SnackbarReducerAction =
  | {
      type: 'ADD_SNACKBAR';
      payload: {
        snackbar: SnackbarState;
        options: AddSnackbarOptions;
      };
    }
  | {
      type: 'UPDATE_SNACKBAR';
      payload: Partial<SnackbarState> & { id: string };
    }
  | { type: 'REMOVE_SNACKBAR'; payload: { id: string } };

export function snackbarReducer(
  state: SnackbarState[],
  action: SnackbarReducerAction,
): SnackbarState[] {
  switch (action.type) {
    case 'ADD_SNACKBAR':
      return addNewSnackbar(state, action.payload.snackbar, action.payload.options);
    case 'UPDATE_SNACKBAR': {
      const { id, ...data } = action.payload;
      return updateSnackbar(state, id, data);
    }
    case 'REMOVE_SNACKBAR':
      return removeSnackbar(state, action.payload.id);
    default:
      return state;
  }
}

export function addNewSnackbar(
  state: SnackbarState[],
  snackbar: SnackbarState,
  options: AddSnackbarOptions,
) {
  const { showLatestOnTop, snackbarLimit } = options;

  if (state.length >= snackbarLimit) {
    console.warn('Snackbar limit reached. Please close some notifications before adding new ones.');
    return state;
  }

  if (showLatestOnTop) {
    return [snackbar, ...state];
  }
  return [...state, snackbar];
}

export function updateSnackbar(
  state: SnackbarState[],
  id: string,
  data: Partial<Omit<SnackbarState, 'id'>>,
) {
  return state.map((snackbar) => {
    if (snackbar.id === id) {
      return { ...snackbar, ...data };
    }
    return snackbar;
  });
}

export function removeSnackbar(state: SnackbarState[], id: string) {
  return state.filter((snackbar) => snackbar.id !== id);
}
